<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        <Cart @snackbarNotification="snackbarNotification" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from 'axios';
const headers = {'Accept': 'application/json'};
const fireapi = 'https://us-central1-shark-sellers.cloudfunctions.net/main';
import Cart from '@/components/Cart'

export default {
  components: {Cart},
  data() {
    return {
      loading:false,
      dialog:false,
      
    }
  },
  methods: {
    snackbarNotification(text, color){
      this.$emit('snackbarNotification', text, color)
    },
  },
  async created(){
  },
}
</script>

<style>

</style>